import { REDUCER_ACTION_TYPES } from "./constants";
import type { CalendarState, CalendarViewRange } from "./utils";
import { EventInput } from "@fullcalendar/core";

type CalendarActionPayloadMap = {
  [REDUCER_ACTION_TYPES.CHANGE_DATE_RANGE]: {
    currentViewRange: CalendarViewRange;
  };
  [REDUCER_ACTION_TYPES.UPDATE_CALENDAR_SCHEDULES]: { events: EventInput[] };
  [REDUCER_ACTION_TYPES.CHANGE_FILTER_SPORT_COURT]: { sportCourtId: string[] };
  [REDUCER_ACTION_TYPES.CHANGE_FILTER_STATUS]: { status: string };
  [REDUCER_ACTION_TYPES.CHANGE_FILTER_CUSTOMER]: { customerId: string };
  [REDUCER_ACTION_TYPES.UPDATE_EVENT]: EventInput;
};

type ActionsWithPayload = {
  [K in keyof CalendarActionPayloadMap]: {
    type: K;
    payload: CalendarActionPayloadMap[K];
  };
}[keyof CalendarActionPayloadMap];

type RefreshAction = { type: typeof REDUCER_ACTION_TYPES.REFRESH_CALENDAR };

export type CalendarAction = ActionsWithPayload | RefreshAction;

export const calendarReducer = (
  state: CalendarState,
  action: CalendarAction
): CalendarState => {
  switch (action.type) {
    case REDUCER_ACTION_TYPES.CHANGE_DATE_RANGE:
      return {
        ...state,
        currentViewRange: action.payload.currentViewRange,
      };
    case REDUCER_ACTION_TYPES.UPDATE_CALENDAR_SCHEDULES:
      return {
        ...state,
        events: action.payload.events,
      };
    case REDUCER_ACTION_TYPES.REFRESH_CALENDAR:
      return {
        ...state,
        refresh: state.refresh + 1,
      };
    case REDUCER_ACTION_TYPES.CHANGE_FILTER_SPORT_COURT: {
      const newSportCourtIds = action.payload.sportCourtId;
      return {
        ...state,
        query: {
          ...state.query,
          sportCourtId: newSportCourtIds,
        },
      };
    }
    case REDUCER_ACTION_TYPES.CHANGE_FILTER_STATUS: {
      const newStatus = action.payload.status;
      return {
        ...state,
        query: {
          ...state.query,
          status: newStatus,
        },
      };
    }
    case REDUCER_ACTION_TYPES.CHANGE_FILTER_CUSTOMER: {
      const customerId = action.payload.customerId;
      return {
        ...state,
        query: {
          ...state.query,
          customerId,
        },
      };
    }
    case REDUCER_ACTION_TYPES.UPDATE_EVENT:
      return {
        ...state,
        events: state.events.map((event) => {
          if (event.id === action.payload.id) {
            return action.payload;
          }
          return event;
        }),
      };
    default:
      return state;
  }
};
